import Axios from "axios";

export function UpdateStatus(boardId, campaignId, status,cb){
    Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/update-status", {
        boardId: boardId,
        campaignId:campaignId,
        status :  status,
    },{
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => {
        cb(response.data.board);
    }).catch(error => {
        console.log(error);
    });
}
